/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Validation_Tier_RequiredInputs */



/**
* | output |
* | --- |
* | "Please select a tier." |
*
* @param {Partner_Admin_Validation_Tier_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_validation_tier_required = /** @type {((inputs?: Partner_Admin_Validation_Tier_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Validation_Tier_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte eine Stufe auswählen.")
	return /** @type {LocalizedString} */ ("Please select a tier.")
});